import * as React from 'react'

import { toast } from '@/lib/toasts/api'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import {
  isPrintJobRunning,
  usePrintJobRunning,
  usePrintJobStore,
} from '../stores/printJobStore'


export const usePrintJobGuard = () => {
  const { t } = useLocalize()
  const isGenerating = usePrintJobRunning()

 
  const busyTooltip = isGenerating
    ? t('printout.generation-in-progress')
    : undefined

  const runPrintJob = React.useCallback(
    async <T>(job: () => Promise<T> | T): Promise<T | undefined> => {
      if (isPrintJobRunning()) {
        toast.warning({ text: t('printout.generation-in-progress') })
        return undefined
      }

      const finishJob = usePrintJobStore.getState().beginJob()
      try {
        return await job()
      } finally {
        finishJob()
      }
    },
    [t],
  )

  return { isGenerating, busyTooltip, runPrintJob }
}

export default usePrintJobGuard
